<style>
    .datetime-picker-dropdown {
        top: 36px !important;

    }

    .datetime-picker-dropdown .btn {
        padding: 5px 9px !important;
    }
</style>

<app-search [showFilter]="true"></app-search>

<div class="row" style="margin:0px;">
  <div class="col-md-12">
    <div>
      <div class="panel-body">
        <div class="row">
          <div class="col-md-12">
            <h3 style="margin-top:0">
              <span *ngIf="currentDataset === 'beach'">Beach</span>
              <span *ngIf="currentDataset === 'tierii'">Tier II</span>
              <span *ngIf="currentDataset === 'solidwaste'">Solid Waste</span>
              <span *ngIf="currentDataset === 'precerclis'">Pre-CERCLIS</span>
              <span *ngIf="currentDataset === 'fuds'">FUD</span>
              <span *ngIf="currentDataset === 'brownfields'">Brownfield</span>
              <span *ngIf="currentDataset === 'standby'">Standby Generator</span>
              <span *ngIf="currentDataset === 'ust'">Storage Tanks</span>
              <span *ngIf="currentDataset === 'onestop'">One Stop</span>
              <span *ngIf="currentDataset === 'pesticides'">Pesticides</span>
              <span *ngIf="currentDataset === undefined || currentDataset === ''">All </span>
              Sites
              <small><select style="margin:10px 10px" name="actionSelect" id="actionSelect"
                             [(ngModel)]="actionSelected.value"
                             (ngModelChange)="selectionChange()"
              >
                <option *ngFor="let option of bulkOptions" [value]="option.value">
                  {{ option.label }}
                </option>
              </select>
                <app-help-docs-links recordType="actions" color="#333333"></app-help-docs-links>
              </small>
            </h3>
          </div>
          <div class="col-md-3">

          </div>
        </div>
        <b>Total Sites Found: </b>{{ sitesService.meta.count }}
        <div class="table-responsive">
          <table id="listViewTable" class="table table-striped panel panel-default"
                 style="table-layout:auto">
            <thead class="panel-heading">
            <tr style="padding:0; margin:0; width: 100%;">
              <th style="width: 10px; line-height:20px"><input id="allCheckbox" type="checkbox"
                                                               (click)="selectAll()"
                                                               [(ngModel)]="isAllSelected"/></th>
              <th [class]="(currentDataset === '' || currentDataset === undefined) ? 'col-lg-8 col-md-7 col-xs-7' : 'col-lg-4 col-md-7 col-xs-7'"
                  style="line-height:20px;">Name
                <app-table-sort-order field="name"
                                      [ordering]="sitesService.searchParam.ordering"></app-table-sort-order>
              </th>
              <th *ngIf="currentDataset === 'beach'" class="col-lg-2 col-md-2 col-xs-2"
                  style="line-height: 20px;">
                Latest Sample Taken
                <app-table-sort-order field="beaches_latest_sample_date"
                                      [ordering]="sitesService.searchParam.ordering"></app-table-sort-order>
              </th>
              <th *ngIf="currentDataset === 'beach'" class="col-lg-1 col-md-2 col-xs-2"
                  style="line-height: 20px;">
                Latest Result (#/100ml)
              </th>
              <th *ngIf="currentDataset === 'beach'" class="col-lg-1 col-md-2 col-xs-2"
                  style="line-height: 20px;">
                Latest Geomean (#/100ml)
              </th>
              <th *ngIf="currentDataset === 'beach'" class="col-lg-2 col-md-2 col-xs-2 text-center"
                  style="line-height: 20px;">
                Current Status
              </th>
              <th *ngIf="currentDataset === 'precerclis'" class="col-lg-2 col-md-2 col-xs-2"
                  style="line-height: 20px;">Exposure Pathway
              </th>
              <th *ngIf="currentDataset === 'precerclis'" class="col-lg-2 col-md-2 col-xs-2"
                  style="line-height: 20px;">Circumstances
              </th>
              <th *ngIf="currentDataset === 'precerclis'" class="col-lg-2 col-md-2 col-xs-2"
                  style="line-height: 20px;">Source
              </th>
              <th *ngIf="currentDataset === 'tierii'" class="col-lg-2 col-md-2 col-xs-2"
                  style="line-height: 20px;">
                NAICS Code
              </th>
              <th *ngIf="currentDataset === 'tierii'" class="col-lg-2 col-md-2 col-xs-2"
                  style="line-height: 20px;">
                D&B Number
              </th>
              <th *ngIf="currentDataset === 'tierii'" class="col-lg-2 col-md-2 col-xs-2"
                  style="line-height: 20px;">
                Reporting Year
              </th>
              <th *ngIf="currentDataset === 'solidwaste'" class="col-lg-1 col-md-2 col-xs-2"
                  style="line-height: 20px;">Permit Type
              </th>
              <th *ngIf="currentDataset === 'solidwaste'" class="col-lg-1 col-md-2 col-xs-2"
                  style="line-height: 20px;">Permit Number
              </th>
              <th *ngIf="currentDataset === 'solidwaste'" class="col-lg-2 col-md-2 col-xs-2"
                  style="line-height: 20px;">Permit App Date
                <app-table-sort-order field="solidwaste_current_permit_date"
                                      [ordering]="sitesService.searchParam.ordering"></app-table-sort-order>
              </th>
              <th *ngIf="currentDataset === 'solidwaste'" class="col-lg-2 col-md-2 col-xs-2"
                  style="line-height: 20px;">Latest Inspection
                <app-table-sort-order field="most_recent_sw_inspection"
                                      [ordering]="sitesService.searchParam.ordering"></app-table-sort-order>
              </th>
              <th *ngIf="currentDataset === 'solidwaste'" class="col-lg-2 col-md-2 col-xs-2"
                  style="line-height: 20px;"># of Complaints in 30 days
              </th>
              <th *ngIf="currentDataset === 'solidwaste'" class="col-lg-2 col-md-2 col-xs-2"
                  style="line-height: 20px;">Latest Complaint #
              </th>
              <th *ngIf="currentDataset === 'solidwaste'" class="col-lg-1 col-md-2 col-xs-2"
                  style="line-height: 20px;">Latest Complaint Status
              </th>
              <th *ngIf="currentDataset === 'standby'" class="col-lg-2 col-md-2 col-xs-2"
                  style="line-height: 20px;">Total Emissions Tonnage
              </th>
              <th *ngIf="currentDataset === 'standby'" class="col-lg-2 col-md-2 col-xs-2"
                  style="line-height: 20px;">Total Generators
              </th>
              <th *ngIf="currentDataset === 'ust'" class="col-lg-2 col-md-2 col-xs-2"
                  style="line-height: 20px;">Facility ID
              </th>
              <th *ngIf="currentDataset === 'ust'" class="col-lg-2 col-md-2 col-xs-2"
                  style="line-height: 20px;">Tanks (Active/TOTAL)
              </th>
              <th *ngIf="currentDataset === 'ust'" class="col-lg-2 col-md-2 col-xs-2"
                  style="line-height: 20px;">Compliance
              </th>
              <th *ngIf="currentDataset === 'ust'" class="col-lg-2 col-md-2 col-xs-2"
                  style="line-height: 20px;">Last Inspection
              </th>
              <th *ngIf="currentDataset === 'ust'" class="col-lg-2 col-md-2 col-xs-2"
                  style="line-height: 20px;">Outstanding Actions
              </th>
              <th *ngIf="currentDataset === 'onestop'" class="col-lg-2 col-md-2 col-xs-2"
                  style="line-height: 20px;">Reference #
              </th>
              <th *ngIf="currentDataset === 'pesticides'" class="col-lg-2 col-md-2 col-xs-2"
                  style="line-height: 20px;">Latest Inspection
              </th>
              <th *ngIf="currentDataset === 'pesticides'" class="col-lg-2 col-md-2 col-xs-2"
                  style="line-height: 20px;">Date Issued
              </th>
<!--              <th [class]="(currentDataset === '' || currentDataset === undefined) ? 'col-lg-2 col-md-2 col-xs-2' : 'col-lg-1 col-md-2 col-xs-2'"-->
<!--                  *ngIf="currentDataset | isEmpty">Program Data-->
<!--              </th>-->
              <th [class]="(currentDataset === '' || currentDataset === undefined) ? 'col-lg-2 col-md-2 col-xs-2' : 'col-lg-1 col-md-2 col-xs-2'"
                  style="line-height:20px;">
                Site ID
                <app-table-sort-order field="site_id"
                                      [ordering]="sitesService.searchParam.ordering"></app-table-sort-order>
              </th>
              <th [class]="(currentDataset === '' || currentDataset === undefined) ? 'col-lg-2 col-md-2 col-xs-2' : 'col-lg-1 col-md-2 col-xs-2'"
                  style="line-height:20px;"
                  *ngIf="currentDataset !== 'tierii'">
                Village
                <app-table-sort-order field="village"
                                      [ordering]="sitesService.searchParam.ordering"></app-table-sort-order>
              </th>
              <th [class]="(currentDataset === '' || currentDataset === undefined) ? 'col-lg-3 col-md-3 col-xs-3' : 'col-lg-2 col-md-3 col-xs-3'"
                  style="line-height:20px; white-space:nowrap;">
                Last Edited On
                <app-table-sort-order field="last_edited_date"
                                      [ordering]="sitesService.searchParam.ordering"></app-table-sort-order>
              </th>
              <th></th>
              <th align="left" style="width:30px; line-height:20px;">
                <app-help-docs-links recordType="sorting" color="#333333"></app-help-docs-links>
              </th>

            </tr>
            </thead>
            <tbody>
            <tr *ngIf="sitesService.loading">

              <td></td>
              <td colspan="100%"><i class="fa fa-spinner fa-pulse"></i></td>
            </tr>
            <tr *ngFor="let site of sitesService.sites">

              <td><input id="checkbox_{{ site.globalid }}" type="checkbox" [(ngModel)]="site.selected"/></td>
              <td><a [routerLink]="['/site', site.globalid]">
                {{ site.name ? site.name : site.streetaddress ? site.streetaddress : site.site_id }}
              </a></td>
              <td *ngIf="currentDataset === 'beach'">{{ site.beaches_latest_sample_date | date:'mediumDate' }}
              </td>
              <td *ngIf="currentDataset === 'beach'">{{ site.beaches_latest_result }}</td>
              <td *ngIf="currentDataset === 'beach'">{{ site.beaches_latest_geomean }}</td>
              <td *ngIf="currentDataset === 'beach'" class="text-center">
                <img *ngIf="site.beaches_current_status === true"
                     src="assets/BadBeachSign.png"
                     width="33px"/>
                <img *ngIf="site.beaches_current_status === false"
                     src="assets/GoodBeachSign.png"
                     width="45px"/>
              </td>
              <td *ngIf="currentDataset === 'precerclis'">{{ site.precerclis_exposure }}</td>
              <td *ngIf="currentDataset === 'precerclis'">{{ site.precerclis_circumstances }}</td>
              <td *ngIf="currentDataset === 'precerclis'">{{ site.precerclis_source }}</td>
              <td *ngIf="currentDataset === 'tierii'">{{ site.tierii_naics }}</td>
              <td *ngIf="currentDataset === 'tierii'">{{ site.tierii_dbnumber }}</td>
              <td *ngIf="currentDataset === 'tierii'">{{ site.most_recent_tierii_cert }}</td>
              <td *ngIf="currentDataset === 'solidwaste'">{{ site.solidwaste_current_permit_type | titlecase }}
              </td>
              <td *ngIf="currentDataset === 'solidwaste'">{{ site.solidwaste_current_permit_number }}</td>
              <td *ngIf="currentDataset === 'solidwaste'">{{ site.solidwaste_current_permit_date | date:'mediumDate' }}
              </td>
              <td *ngIf="currentDataset === 'solidwaste'">{{ site.most_recent_sw_inspection | date:'mediumDate' }}
              </td>
              <td *ngIf="currentDataset === 'solidwaste'">{{ site.solidwaste_30day_complaints }}</td>
              <td *ngIf="currentDataset === 'solidwaste'">{{ site.solidwaste_latest_complaint_number }}</td>
              <td *ngIf="currentDataset === 'solidwaste'">{{ site.solidwaste_latest_complaint_status }}
              <td *ngIf="currentDataset === 'standby'">{{ site.standby_tonnage }}</td>
              <td *ngIf="currentDataset === 'standby'">{{ site.standby_generator_count }}</td>
              <td *ngIf="currentDataset === 'ust'">{{ site.ust_id }}</td>
              <td *ngIf="currentDataset === 'ust'">{{ site.ust_tanks_active_count }}</td>
              <td *ngIf="currentDataset === 'ust'">{{ site.ust_compliance }}</td>
              <td *ngIf="currentDataset === 'ust'">{{ site.ust_last_inspection }}</td>
              <td *ngIf="currentDataset === 'ust'">{{ site.ust_actions }}</td>
              <td *ngIf="currentDataset === 'onestop'">{{ site.onestop_reference_number }}</td>
              <td *ngIf="currentDataset === 'pesticides'">{{ site.pesticides_latest_inspection }}</td>
              <td *ngIf="currentDataset === 'pesticides'">{{ site.pesticides_date_issued }}</td>
<!--              <td *ngIf="currentDataset | isEmpty">{{ site.interests }}</td>-->
              <td>{{ site.site_id }}
              <td *ngIf="currentDataset !== 'tierii'">{{ site.village | display:sitesService.meta.fields.village.choices }}
              </td>
              <td>{{ site.last_edited_date | date:'short' }}</td>
              <td><span (click)="openSummaryModal(site)" style="cursor: pointer"
                        ngbTooltip="Click to view summary" placement="left"><i
                  class="fa fa-file-text"></i> </span></td>
              <td></td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="text-center" style="margin-top: 10px;">
            <ngb-pagination [collectionSize]="sitesService.meta.count" [(page)]="currentPage" [maxSize]="5"
                  pageSize="25" [boundaryLinks]="false" (pageChange)="switchPage()" class="pagination">
  </ngb-pagination>
          <!--                    <ngb-pagination [total="Sites.totalItems" ng-model="currentPage" max-size="5"-->
          <!--                        previous-text="&lsaquo;" next-text="&rsaquo;"-->
          <!--                        items-per-page="25" boundary-link-numbers="true" ng-change="switchPage()" class="pagination"></ngb-pagination>-->
        </div>
      </div>
    </div>
  </div>
</div>
